import React from "react";
import { LabelProps } from "./types";
import styles from "./styles";

//Uses default label css unless one is provided
const Label = (props: LabelProps) => {
    const { htmlFor, cssName, text } = props;
    return (
        <label htmlFor={htmlFor} className={cssName ?? styles.elements.label}>{text}</label>
    );
}

export default Label;